// Group an order's selected article IDs into the store's sections for display.
// Any selected ID that is no longer in any section (a discontinued product that
// still has an order against it) is collected into a trailing group so the line
// is never lost from the cart / order viewer / PDF.
export const buildOrderSections = (sectionsData, selectedArticleIds) => {
  const selected = new Set(selectedArticleIds || []);
  const placed = new Set();
  const groups = [];

  (sectionsData || []).forEach((section) => {
    const articles = (section.articles || []).filter((id) => selected.has(id));
    articles.forEach((id) => placed.add(id));
    if (articles.length > 0) {
      groups.push({
        id: section.id,
        name: section.name,
        articles,
        isDiscontinued: false
      });
    }
  });

  const orphans = [...selected].filter((id) => !placed.has(id));
  if (orphans.length > 0) {
    groups.push({
      id: "__discontinued__",
      name: "No longer in the store",
      articles: orphans,
      isDiscontinued: true
    });
  }

  return groups;
};
